export default "__VITE_ASSET__bf944459__"